import { render, staticRenderFns } from "./MerchantLabel.vue?vue&type=template&id=9853530a&scoped=true&"
import script from "./MerchantLabel.vue?vue&type=script&lang=js&"
export * from "./MerchantLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9853530a",
  null
  
)

component.options.__file = "MerchantLabel.vue"
export default component.exports